module.exports = __webpack_public_path__ + "static/media/10D.dbb3850c.svg";